import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { AbsenceTypeIcon } from '@vk-hr-tek/ui/AbsenceTypeIcon';

import { EmployeeAbsenceWithFormat } from '../../types';

interface AbsenceStatusProps {
  absence: EmployeeAbsenceWithFormat;
}

export const AbsenceStatus = ({ absence }: AbsenceStatusProps) => {
  return (
    <Box
      position="absolute"
      bgcolor="bg.light.primary"
      display="flex"
      alignItems="center"
      justifyContent="center"
      radius="round"
      bottom={0}
      right={-4}
      width={20}
      height={20}
    >
      <AbsenceTypeIcon
        variant={absence.absence_group.nick}
        color={
          absence.isCurrentMoment
            ? 'original.brand.primary'
            : 'stroke.tertirary'
        }
      />
    </Box>
  );
};
